const getOperatingSystem = (userAgent: string) => {
  const match = userAgent.match(/(?:\(|; )([^;)]+)\)/);

  return match ? match[1] : 'Unknown';
};

export default getOperatingSystem;
